module.exports = __webpack_public_path__ + "media/icons/paperclip-4694b3ff.png";